import { BundleItemDataExtended, ReorderBundlePagesPasteLocationTypeKeys } from '@/api';

export type GridItem = {
  id: string;
  pageIndex: number;
  pageData: BundleItemDataExtended;
};

export type GroupSectionLabel = {
  id: string;
  type: string;
  text: string;
  level: number;
};

export interface GridDataGroupIds {
  groupProviderId?: string;
  groupCategoryId?: string;
  groupSubCategoryId?: string;
  groupClusterId?: string;
  groupDocumentId?: string;
}

export type GridGroup = GridDataGroupIds & {
  id: string;
  labels: GroupSectionLabel[];
  items: GridItem[];
};

export enum VirtualRowType {
  GroupHeader = 'groupHeader',
  PageIdsRow = 'pageIdsRow',
}

export enum ThumbnailPageInsertPosition {
  Before = -1,
  After = 1,
}

export interface HandleDropRequestProps {
  targetParentId: string;
  anchorPageId: string;
  targetIndex: number;
  pageIds: string[];
  pasteLocation: ReorderBundlePagesPasteLocationTypeKeys;
  rollbackGroups: GridGroup[];
}

export interface IsDropRestrictedProps {
  activeGroup: GridGroup;
  group: GridGroup;
}
